export default function (id, locale) {
  return `mutation UpdateLocale {
    updateLocale(crmLeadAccessToken: "${id}", locale: "${locale}") {
      accessToken
      locale
    }
  }`
}
